import React from 'react';
import '../../assets/styles/receipt.sass';

const ReceiptList = ({ bill }) => {
  return (
    <div className="receipt-breakdown-container">
      {Object.keys(bill.items).reduce((arr, breakdown) => {
        const { items: { [breakdown]: value } = {} } = bill || {};
        if (!value) return arr;
        const label = breakdown === 'cbd_surcharge' ? 'CRZ Toll' : '';
        return [
          ...arr,
          <div className="receipt-breakdown" key={breakdown}>
            <div className="receipt-label">{label || breakdown.split('_').join(' ')}:</div>
            <div className="receipt-value">${(value / 100).toFixed(2)}</div>
          </div>,
        ];
      }, [])}
    </div>
  );
};

export default ReceiptList;
